import { render } from "./CourseCard.vue?vue&type=template&id=6584b274&scoped=true"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"

import "./CourseCard.vue?vue&type=style&index=0&id=6584b274&scoped=true&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6584b274"]])

export default __exports__